<template>
	<div class="history">
		<ul class="left-box">
			<el-badge :value="list.type == 1 ? '专家' : '家长'" class="item" v-for="(list,i) in listinfo" :key="i" style="display: block;margin-right: 15px">
				<li @click="jumper(list.id,list.report_file_pdf)" :class="{active:list.id==chose}" style="">
					{{list.do_time}}
				</li>
			</el-badge>
            <li style="width: 80px;height:40px;background:#8CBB77;">
                <a :href="baseUrl + 'saas/ceping/show_pdf_view?type=print&listid='+listid" target="_blank" class="but_a" >打印报告</a>
            </li>
		</ul>

		<div class="content">
			<div class="tabs">
				<iframe :src="report_file_pdf" width="100%" height="100%" style="width:107%;border: 0;overflow-y: scroll"></iframe>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
    data() {
        return{
            listid:'',
            listinfo:'',
            report_file_pdf:'',
            chose:'',
			token:'',
			baseUrl: ''
        }
  },
  created() {
	  this.baseUrl = process.env.apiUrl
  },
    filters:{
        typename: function (value) {
            if(value == 1) return "专家测评"
            if(value == 2) return "家长测评"
        }
    },
    methods:{

        jumper:function (index,pdffile) {
            this.chose = index;
            this.listid = index;
            this.report_file_pdf = process.env.apiUrl + "saas/ceping/show_pdf_view?listid="+index;
        },
//        getQueryVariable(variable){
//            var query = window.location.search.substring(1);
//            var vars = query.split("&");
//            for (var i=0;i<vars.length;i++) {
//                var pair = vars[i].split("=");
//                if(pair[0] == variable){return pair[1];}
//            }
//            return(false);
//        }


    },
    mounted:function(){
        this.listid = this.$route.query.listid;
        this.chose = this.listid;
        this.token = $.cookie('token');
        let self=this;

        $.ajax({
            url:process.env.apiUrl + `saas/ceping/get_report`,
            type:"post",
            dataType:"json",
            data:{
                list_id:self.listid,
                token:self.token
            },
            success:function(data){
                console.log(data)
                if(data.status == 1){
                    self.listinfo=data.listinfo;
                    self.report_file_pdf=process.env.apiUrl + "saas/ceping/show_pdf_view?listid="+self.listid;
                }else{
                    alert(data.msg);
                }

            }
        });
    }

}
</script>

<style type="text/css">
	* {
		margin: 0;
		padding: 0;
	}

	#app {
		width: 100%;

	}

	.history .left-box .el-badge__content.is-fixed {
		top: 8px;
		right: 35px;
	}

	.left-box {
		/*width: 15%;*/
		box-sizing: border-box;
		width: 100%;
		padding: 10px;
		display: flex;
		flex-wrap: wrap;

	}

	.left-box li {
		margin-right: 5px;
		margin-bottom: 5px;
	}

	.left-box li {
		list-style: none;
		width: 150px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		color: #8CBB77;
		border-radius: 5px;
		/*font-size: 18px;*/
		box-shadow: 3px 3px 3px 2px #ededed;
	}

	.left-box li.active {
		background: #8CBB77;
		color: white;
	}

	.history .content {
		box-sizing: border-box;
		width: 100%;
		/*background: aquamarine;*/
		padding: 10px 8px;
	}

	.history .tabs {
		width: 100%;
		height: 1000px;
		-webkit-overflow-scrolling: touch;
		/*overflow-y: scroll;*/
		overflow: hidden;
	}

	.nada {
		display: none;
	}

	#app .history ul {
		box-sizing: border-box;
		padding-left: 20px;
		padding-right: 20px;
	}

	.dialog .el-dialog__header{
		background-color: #8CBB77;
		padding: 12px;
	}
	.but_a{
		color: white;
	}
	.but_a:hover{
		color: white;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ceping/historylc.vue